
import ScanBarcode from "../../../assets/filled/ScanBarcode.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ScanBarcodeIcon({ className, dataTestid = "ScanBarcodeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ScanBarcode data-testid={dataTestid} className={classes} {...rest} />
  );
}
